import { render, staticRenderFns } from "./emailTemplateItem.vue?vue&type=template&id=65ea249c&scoped=true"
import script from "./emailTemplateItem.vue?vue&type=script&lang=js"
export * from "./emailTemplateItem.vue?vue&type=script&lang=js"
import style0 from "./emailTemplateItem.vue?vue&type=style&index=0&id=65ea249c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ea249c",
  null
  
)

export default component.exports